import auth from './auth/reducer';
import crm from './crm/reducer';
import qna from './qna/reducer';
import global from './global/reducer';
import analytics from './analytics/reducer';

export default { global, auth, crm, qna, analytics };
